import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCcQjIcKAwkkNcCEYIbx1WP_ILE6z52SF8",
  authDomain: "noti-app-a468e.firebaseapp.com",
  databaseURL: "https://noti-app-a468e-default-rtdb.firebaseio.com",
  projectId: "noti-app-a468e",
  storageBucket: "noti-app-a468e.firebasestorage.app",
  messagingSenderId: "810399752541",
  appId: "1:810399752541:web:fcc438d33081aeb77cc8b4",
  measurementId: "G-FERYXBDBTW"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
export default app;
